import React, { Fragment } from 'react'


  const SortCriteriaCompact = ({
    sortCriteria,
    selectedOption = [
      ...sortCriteria.filter(sort => sort.selected === true),
      {}
    ][0],
    count=sortCriteria.length,
    onFacetChangeSort,
  }) => (
    <div className="columns sort">
      <span className={`${count>0? 'sort__heading': 'sort__heading hide'}`}>Sort</span>
      <ul className="form__input sort__list" value={selectedOption.value}>
        {sortCriteria &&
          sortCriteria.map(({ text, value, selected }, index) => (
            <li
              value={value}
              className={`subnav__item sort__item ${selected ? 'active' : ''}`}
              key={`sorteriaCompact-${index}`}
              onClick={event => onFacetChangeSort(value)}
            >
              {text}{' '}
            </li>
          ))}
      </ul>
    </div>
  )


export default SortCriteriaCompact
